import ChatFlowIntegration from 'services/api/ChatFlowIntegration';

export const FIND_CHAT_FLOW_INTEGRATION = 'FIND_CHAT_FLOW_INTEGRATION';
export const FIND_CHAT_FLOW_INTEGRATION_PENDING = 'FIND_CHAT_FLOW_INTEGRATION_PENDING';
export const FIND_CHAT_FLOW_INTEGRATION_FULFILLED = 'FIND_CHAT_FLOW_INTEGRATION_FULFILLED';

export const LOAD_CHAT_FLOW_INTEGRATIONS = 'LOAD_CHAT_FLOW_INTEGRATIONS';
export const LOAD_CHAT_FLOW_INTEGRATIONS_PENDING = 'LOAD_CHAT_FLOW_INTEGRATIONS_PENDING';
export const LOAD_CHAT_FLOW_INTEGRATIONS_FULFILLED = 'LOAD_CHAT_FLOW_INTEGRATIONS_FULFILLED';

export const CREATE_CHAT_FLOW_INTEGRATION = 'CREATE_CHAT_FLOW_INTEGRATION';
export const CREATE_CHAT_FLOW_INTEGRATION_PENDING = 'CREATE_CHAT_FLOW_INTEGRATION_PENDING';
export const CREATE_CHAT_FLOW_INTEGRATION_FULFILLED = 'CREATE_CHAT_FLOW_INTEGRATION_FULFILLED';

export const UPDATE_CHAT_FLOW_INTEGRATION = 'UPDATE_CHAT_FLOW_INTEGRATION';
export const UPDATE_CHAT_FLOW_INTEGRATION_PENDING = 'UPDATE_CHAT_FLOW_INTEGRATION_PENDING';
export const UPDATE_CHAT_FLOW_INTEGRATION_FULFILLED = 'UPDATE_CHAT_FLOW_INTEGRATION_FULFILLED';

export const DESTROY_CHAT_FLOW_INTEGRATION = 'DESTROY_CHAT_FLOW_INTEGRATION';
export const DESTROY_CHAT_FLOW_INTEGRATION_PENDING = 'DESTROY_CHAT_FLOW_INTEGRATION_PENDING';
export const DESTROY_CHAT_FLOW_INTEGRATION_FULFILLED = 'DESTROY_CHAT_FLOW_INTEGRATION_FULFILLED';

export const TEST_CHAT_FLOW_INTEGRATION_CONNECTION = 'TEST_CHAT_FLOW_INTEGRATION_CONNECTION';
export const TEST_CHAT_FLOW_INTEGRATION_CONNECTION_PENDING =
  'TEST_CHAT_FLOW_INTEGRATION_CONNECTION_PENDING';
export const TEST_CHAT_FLOW_INTEGRATION_CONNECTION_FULFILLED =
  'TEST_CHAT_FLOW_INTEGRATION_CONNECTION_FULFILLED';

const load = () => ({
  type: LOAD_CHAT_FLOW_INTEGRATIONS,
  payload: ChatFlowIntegration.list(),
});

const create = form => ({
  type: CREATE_CHAT_FLOW_INTEGRATION,
  payload: ChatFlowIntegration.create(form),
});

const update = (id, form) => ({
  type: UPDATE_CHAT_FLOW_INTEGRATION,
  payload: ChatFlowIntegration.update(id, form),
  meta: { IntegrationId: id },
});

const find = id => ({
  type: FIND_CHAT_FLOW_INTEGRATION,
  payload: ChatFlowIntegration.find(id),
  meta: { IntegrationId: id },
});

const destroy = id => ({
  type: DESTROY_CHAT_FLOW_INTEGRATION,
  payload: ChatFlowIntegration.destroy(id),
  meta: { IntegrationId: id },
});

const testConnection = id => ({
  type: TEST_CHAT_FLOW_INTEGRATION_CONNECTION,
  payload: ChatFlowIntegration.testConnection(id),
  meta: { IntegrationId: id },
});

export default {
  create,
  destroy,
  find,
  load,
  testConnection,
  update,
};
